var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParagraphQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8692 0.500305H6.71924C3.62067 0.500305 0.979956 2.9033 0.872813 5.99144C0.757813 9.23199 3.35853 11.8957 6.58353 11.8957H8.29781V15.5991C8.29781 16.071 8.68174 16.4538 9.15496 16.4538C9.62817 16.4538 10.0121 16.0728 10.0121 15.5991V2.20961H11.7264V15.5991C11.7264 16.071 12.1103 16.4538 12.5835 16.4538C13.0567 16.4538 13.4407 16.0728 13.4407 15.5991V2.20961H14.8692C15.3442 2.20961 15.7264 1.82679 15.7264 1.35496C15.7264 0.882762 15.3442 0.500305 14.8692 0.500305ZM8.29781 10.1864H6.58353C4.37281 10.1864 2.58353 8.40227 2.58353 6.19798C2.58353 3.99369 4.37281 2.20961 6.58353 2.20961H8.29781V10.1864Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphQuestion);
export default __webpack_public_path__ + "static/media/paragraph-question.c7bbe72aefc01bcd57213c7d4df0893d.svg";
export { ForwardRef as ReactComponent };